import { QUOTA_EXCEEDED_CODE } from '../constants/errorCodes';
import { logWarning } from './remoteLogger';

const sessionStorage = {
  get: <T>(key: string): string | T | null => {
    const data = window.sessionStorage.getItem(key);

    try {
      if (data === null) return null;
      return JSON.parse(data) as T;
    } catch (error: any) {
      logWarning(
        '[sessionStorage]',
        `Failed to parse JSON for key: ${key}`,
        error
      );
      return null;
    }
  },

  set: (key: string, value: any) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e: any) {
      if (e.name === 'QuotaExceededError' || e.code === QUOTA_EXCEEDED_CODE) {
        logWarning('[sessionStorage]', 'Quota exceeded — clearing storage');
        window.sessionStorage.clear();

        try {
          window.sessionStorage.setItem(key, JSON.stringify(value));
          logWarning('[sessionStorage]', 'Item set successfully after clear.');
        } catch (retryError: any) {
          logWarning(
            '[sessionStorage]',
            'Failed to set item even after clear:',
            retryError
          );
        }
      } else {
        logWarning('[sessionStorage]', 'Failed to set item:', e);
      }
    }
  },

  remove: (key: string) => {
    window.sessionStorage.removeItem(key);
  },

  clear: () => {
    window.sessionStorage.clear();
  },
};

export default sessionStorage;
